import template from '../../reports/ReportsView.html';
import { ReportsController } from '../../reports/ReportsController';
const CustomReports = {
    template,
    controller: ReportsController,
    controllerAs: '$ctrl',
    bindings: {},
};
export default CustomReports;
